import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { useField } from "formik";

import "./phoneFieldWrapper.scss";
import { useTranslation } from "react-i18next";

const PhoneFieldWrapper = ({ name, formik }) => {
  const [, meta] = useField(name);
  return (
    <div className="phone-field">
      <PhoneInput
        country={"de"}
        value={formik.values[name]}
        onChange={(phone) => {
          formik.setFieldValue(name, phone);
        }}
        placeholder="2842394789"
        containerClass="phoneNumberContainer"
        inputClass="phoneNumberInput"
      />
      {meta && meta.touched && meta.error && (
        <p style={{ color: "#d32f2f", fontSize: "0.75rem" }}>{meta.error}</p>
      )}
    </div>
  );
};

export default PhoneFieldWrapper;
